<template>
    <div class="featured-article" @click="viewArticle">
        <a :href="url">
            <img v-if="image !== null" :src="image" />
        </a>
        <div class="content">
            <div class="small">
                <div :class="['icon', icon]"></div>
                {{ authorName }}
            </div>
            <a :href="url">
                <div class="article-title text-bold">{{ articleTitle }}</div>
            </a>
            <div class="small">{{ articleDescription }}</div>

            <div v-if="viewCount !== null" class="small">{{ viewCount }} views</div>

        </div>
    </div>
</template>

<script>

export default {
    name: "FeaturedArticle",
    props: {
        icon: {
            type: String,
            default: "icon-user",
            required: false,
        },
        authorName: {
            type: String,
            required: false,
        },
        viewCount: {
            type: Number,
            required: false,
        },
        image: {
            type: String,
            required: false,
        },
        articleTitle: {
            type: String,
            required: false,
        },
        articleDescription: {
            type: String,
            required: false,
        },
        url: {
            type: String,
            required: true,
        },
    },
};
</script>

<style lang="scss">
@use "~@/common/scss/base/_mixins.scss" as *;
.featured-article {
    border-radius: var(--border-radius);
    overflow: hidden;
    background: white;
    border: 1px solid var(--color-d);

    img {
        display: flex;
        height: 120px;
        width: 100%;
        object-fit: cover;
    }

    .content{
        display: flex;
        padding: 1rem;
        flex-direction: column;
        align-items: flex-start;
        align-self: stretch;

        .small {
            @include f7();
            color: var(--color-5);
        }

        .artile-title {
            @include f6();
            color: var(--color-r10);
        }
    }
}
</style>